import Text from '@/components/global/Text';

const stringToLetters = (text) => {
	let wordLength = text.length;
	let arr = [];

	for (let i = 0; i < wordLength; i++) {
		arr.push(text.charAt(i));
	}

	return (
		<Text
			tag={'span'}
			className='word'>
			{arr.map((i, k) => {
				return (
					<span
						className='letter'
						key={k}>
						{i}
					</span>
				);
			})}
		</Text>
	);
};

export default stringToLetters;
